import { IMAGEKIT_URL_ENDPOINT } from "../constants";

/**
 * https://stackoverflow.com/questions/21485545/is-there-a-way-to-tell-if-an-es6-promise-is-fulfilled-rejected-resolved
 *
 * NB! unnecessary within components, but may be useful outside. Within components, you can just do
 * Promise.then(res => this.data).catch(err => this.error) and check whether error or data exists.
 *
 * USAGE: const newPromise = querablePromise(promise)
 * newPromise.isResolved() // gives true, when promise has resolved
 * ... etc
 * const result = newPromise.then(res => return res).catch(error => throw error) // to get result, or error
 * @param {Promise} promise -- a promise.
 */
export const querablePromise = function(promise) {
  if (promise.isResolved) return promise;
  let isResolved = false;
  let isRejected = false;
  let result = promise
    .then((res) => {
      isResolved = true;
      return res;
    })
    .catch((error) => {
      console.log("reached here");
      isRejected = true;
      throw error;
    });

  result.isPending = () => {
    return !isResolved && !isRejected;
  };
  result.isResolved = () => isResolved;
  result.isRejected = () => isRejected;
  return result;
};

/**
 * @param {String} preferenceName one of 'worktype', 'screenshare', 'microphone'
 */
export const preferenceMapper = function(preferenceName) {
  switch (preferenceName) {
    case "worktype":
      return ["desk", "null", "active"];
    case "screenshare":
      return ["yes", "null", "no"];
    case "microphone":
      return ["off", "null", "on"];
  }
  return ["invalid", "argument", "provided"];
};

export const getImageUrlFromName = function(imageName) {
  return imageName ? IMAGEKIT_URL_ENDPOINT + imageName : null;
};

export const getImageNameFromUrl = function(imageUrl) {
  return imageUrl ? imageUrl.slice(IMAGEKIT_URL_ENDPOINT.length) : null;
};

/* ========== VISIBILITY & FOCUS DETECTION ========== */
/* https://stackoverflow.com/a/65312550/8010396 */

export function checkVisibilitySupport() {
  var visibilityState, visibilityChange;
  if (typeof document.visibilityState !== "undefined") {
    visibilityState = "visibilityState";
    visibilityChange = "visibilitychange";
  } else if (typeof document.mozVisibilityState !== "undefined") {
    visibilityState = "mozVisibilityState";
    visibilityChange = "mozvisibilitychange";
  } else if (typeof document.msVisibilityState !== "undefined") {
    visibilityState = "msVisibilityState";
    visibilityChange = "msvisibilitychange";
  } else if (typeof document.webkitVisibilityState !== "undefined") {
    visibilityState = "webkitVisibilityState";
    visibilityChange = "webkitvisibilitychange";
  }

  return { visibilityChange, visibilityState };
}
